import { useLogError } from './useLogError';
import React from 'react';
import { ErrorData } from '@enuan/chat__utils';

type ErrorState = { error?: Error };

type IErrorBoundaryProps = {
	id: string;
	errorHandler?: (error: Error, info: React.ErrorInfo) => void;
	FallbackRender?: React.ComponentType;
	sendLog?: boolean;
};
export class ErrorBoundaryClass extends React.Component<
	React.PropsWithChildren<
		IErrorBoundaryProps & {
			logError: ReturnType<typeof useLogError>;
		}
	>,
	ErrorState
> {
	state: ErrorState = {
		error: undefined,
	};

	static getDerivedStateFromError(error: Error) {
		return { error };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		this.props.logError(
			'boundary',
			{ error, meta: info },
			this.props.sendLog !== false
		);
		this.props.errorHandler?.(error, info);
	}

	render() {
		if (this.state.error && this.props.FallbackRender) {
			return <this.props.FallbackRender />;
		}
		return <>{this.props.children}</>;
	}
}

export const ErrorBoundary = ({
	children,
	id,
	meta,
	...props
}: React.PropsWithChildren<IErrorBoundaryProps & Pick<ErrorData, 'meta'>>) => {
	const log = useLogError(id, meta);

	return (
		<ErrorBoundaryClass logError={log} id={id} {...props}>
			{children}
		</ErrorBoundaryClass>
	);
};
